import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate("/command", { replace: true }); return; }
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data);
        window.history.replaceState({}, document.title, "/command/dashboard");
        navigate("/command/dashboard", { replace: true, state: { user: r.data } });
      } catch (err) {
        const denied = err?.response?.status === 403;
        console.error("Session exchange failed", err);
        navigate("/command", {
          replace: true,
          state: { authError: denied
            ? "Access denied — this command centre is restricted to the owner."
            : "Sign-in failed. Please try again." },
        });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#1A2421] text-white">
      <div className="flex flex-col items-center gap-4">
        <Loader2 size={32} className="animate-spin text-[#62B848]" />
        <p className="text-white/70">Signing you in…</p>
      </div>
    </div>
  );
}
